import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { DataService } from 'src/app/services/data.service';
import { ConvertService, orderByData, pushToArray } from 'src/app/services/convert.service';
import { GENDERS, DISPLAY_STATUS_OBJECT, PACKAGE_ARR, APP_MEMBER_OBJECT } from 'src/app/dummy/status';
import { TrainingStore } from 'src/app/stores/training/training.store';
import { FireStorageService } from 'src/app/services/fire-storage.service';
import { IReadingMember } from 'src/app/interfaces/student';
import * as firebase from 'firebase/app';
import { MappingService } from 'src/app/services/mapping.service';
import { APP_OBJECTS } from 'src/app/dummy/app';
import { toJS } from 'mobx';
import { FireValidatorsService } from 'src/app/services/fire-validators.service';

@Component({
  selector: 'app-add-reading-user',
  templateUrl: './add-reading-user.component.html',
  styleUrls: ['./add-reading-user.component.scss']
})
export class AddReadingUserComponent implements OnInit {
  @ViewChild('focusInput', { static: false }) inputEl: ElementRef;
  @ViewChild('photoFile', { static: false }) photoFile: ElementRef;

  form: FormGroup;
  school: AbstractControl;
  program: AbstractControl;
  level: AbstractControl;
  memberId: AbstractControl;

  processNew: boolean = false;
  processClose: boolean = false;
  error: any = null;
  isCreate: boolean = false;

  TITLE = 'Add New';
  GENDER: any = GENDERS;
  ITEM: IReadingMember;
  PACKAGES = PACKAGE_ARR;

  START_UPLOAD: boolean;
  uploadPercent: any;
  SELECTED_PICTURE_FILE: any;
  imageSrc: string;

  schoolFilterState: any;
  programFilterState: any;
  levelFilterState: any;

  APP_OBJECTS = APP_OBJECTS;

  LOADING: boolean = true;
  constructor(
    public dialogRef: MatDialogRef<AddReadingUserComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private auth: AuthStore,
    public store: TrainingStore,
    private snackBar: MatSnackBar,
    private ds: DataService,
    private storage: FireStorageService,

  ) { }

  async ngOnInit() {
    const { STUDENT, ACCOUNT_TYPE } = this.data;
    this.TITLE = `Add New ${ACCOUNT_TYPE.text}`
    this.ITEM = STUDENT || null;

    this.form = this.fb.group({
      firstName: [STUDENT ? STUDENT.firstName : null, Validators.compose([Validators.required])],
      lastName: [STUDENT ? STUDENT.lastName : null, Validators.compose([Validators.required])],
      gender: [STUDENT ? STUDENT.gender : GENDERS[0], Validators.compose([Validators.required])],
      dateOfBirth: [STUDENT ? (STUDENT.dateOfBirth && STUDENT.dateOfBirth.toDate()) || new Date() : new Date(), Validators.compose([Validators.required])],
      phoneNumber: [STUDENT ? STUDENT.phoneNumber : null, Validators.compose([Validators.required])],
      email: [STUDENT ? STUDENT.email : null],
      memberOption: [STUDENT ? STUDENT.package || this.PACKAGES[0] : this.PACKAGES[0], Validators.required],
      // memberId: [STUDENT && STUDENT.memberId ? STUDENT.memberId : null, Validators.required, STUDENT && STUDENT.memberId ? FireValidatorsService.checkExistOnEdit(this.ds.firestoreRef(), "users", "memberId", STUDENT.memberId) : FireValidatorsService.checkExist(this.ds.firestoreRef(), "users", "memberId")],
      memberId: [STUDENT ? STUDENT.memberId : null,
        Validators.required,
        FireValidatorsService.checkExist(this.ds.firestoreRef(), "users", "memberId")
      ],

      school: [STUDENT ? STUDENT.organizationKey : null, Validators.compose([Validators.required])],
      appName: [STUDENT ? STUDENT.appName : APP_OBJECTS[0], [Validators.required]],
      program: [STUDENT ? STUDENT.program : null, [Validators.required, MappingService.validSelected.bind(this)]],
      level: [STUDENT ? STUDENT.level : null, [Validators.required, MappingService.validSelected.bind(this)]],
    })
    this.school = this.form.controls['school'];
    this.program = this.form.controls['program'];
    this.level = this.form.controls['level'];
    this.memberId = this.form.controls['memberId'];

    if (STUDENT) {
      this.TITLE = `Edit ${ACCOUNT_TYPE.text}`;
      this.program.enable();
      this.level.enable();
    }
    else {
      this.program.disable();
      this.level.disable();
    }
    const data = pushToArray(await this.ds.companyRef().get().toPromise())
    this.schoolFilterState = MappingService.autoComplete(this.school, data, "name");

    if (STUDENT && ACCOUNT_TYPE.key !== 2) {
      const { organizationKey, program, level, appName } = STUDENT;
      const levels = orderByData(pushToArray(await this.ds.programRef().doc(program.key).collection('levels').get().toPromise()), 'name')
      this.levelFilterState = MappingService.autoComplete(this.level, levels, "name");
      organizationKey && this.school.patchValue(data.find(m => m.key === organizationKey) || null)
      this.form.patchValue({
        program,
        level,
        appName: (appName && APP_OBJECTS.find(m => m.key === appName.key)) || null,
      })
    } else {
      this.program.disable();
      this.level.disable();
    }

    if (STUDENT) {
      const { organizationKey, appName } = STUDENT;

      this.form.patchValue({
        appName: (appName && APP_OBJECTS.find(m => m.key === appName.key)) || null,
        school: data.find(m => m.key === organizationKey) || null,
      })

      this.memberId.disable()

    }

    this.LOADING = false;
  }

  async onSelectedApp(event) {
    const { key } = event.value;
    switch (key) {
      case 2:

        this.level.patchValue(null);
        this.level.enable();
        this.program.enable();
        const list = orderByData(pushToArray(await this.ds.programRef().get().toPromise()), 'name')
        this.programFilterState = MappingService.autoComplete(this.program, list, "name");
        break;
      default:
        this.level.disable();
        this.program.disable();
        break;
    }
  }

  async onOptionSelected(event) {
    const { key } = event.option.value;
    const data = orderByData(pushToArray(await this.ds.programRef().doc(key).collection('levels').get().toPromise()), 'name')
    this.levelFilterState = MappingService.autoComplete(this.level, data, "name");
  }

  displayItem(item: any): string {
    return item ? item.name : item;
  }

  compareWithObj(a: any, b: any): boolean {
    if (b) return a.key === b.key;
  }

  async uploadFilePicture(event) {
    if (event && event.target.files.length > 0) {
      this.SELECTED_PICTURE_FILE = event.target.files[0];
      this.photoFile.nativeElement.value = "";
      if (this.ITEM) {
        //PICTURE
        this.START_UPLOAD = true;
        const file = this.SELECTED_PICTURE_FILE;
        const fileName = file.name;
        const uploadPath = `students/${this.ITEM.key}/${fileName}`;
        const uploadTask = this.storage.uploadSelectedFile(file, uploadPath);
        this.uploadPercent = uploadTask.percentageChanges();
        const files = await this.storage.getFileDetail(file, uploadPath, uploadTask)
        this.ITEM.photoFileDetail = files;
        this.ITEM.photoURL = files.downloadUrl;
        this.store.saveMember(this.ITEM, null, false, (success, res) => {
          if (success) {
            this.snackBar.open("Member has been saved successful.", "Done", { duration: 2500 });
          }
          this.processNew = false;
          this.processClose = false;
          this.SELECTED_PICTURE_FILE = null;
          this.START_UPLOAD = false;
          this.imageSrc = null;
          this.photoFile.nativeElement.value = "";
        })
      }
    }
  }


  async onSave(f: any, isDraft: boolean, isNew: boolean) {
    this.processClose = isDraft ? false : true;
    this.processNew = isDraft;
    this.error = null;
    this.isCreate = true;
    if (this.form.valid) {
      this.form.disable();
      const apps: any[] = [APP_MEMBER_OBJECT.reading.key]
      const { firstName, lastName, phoneNumber, dateOfBirth, email, gender, memberOption, memberId, school, appName, program, level } = f;
      const { STUDENT, ACCOUNT_TYPE } = this.data;
      const { user } = this.auth;
      const item: IReadingMember = {
        key: STUDENT ? STUDENT.key : this.ds.createId(),
        status: DISPLAY_STATUS_OBJECT.ACTIVE,
        isDelete: false,
        created_at: STUDENT ? STUDENT.created_at : this.ds.serverTimestamp(),
        created_by: STUDENT ? STUDENT.created_by : user.uid,
        updated_at: this.ds.serverTimestamp(),
        updated_by: user.uid,
        page_key: ConvertService.pageKey(),
        keyword: [ConvertService.toCapitalize(`${firstName} ${lastName}`), ConvertService.toCapitalize(`${phoneNumber}`), ConvertService.toCapitalize(`${memberId}`)],
        organizationRef: school ? this.ds.companyRef().doc(school.key).ref : null,
        organizationKey: (school && school.key) || null,
        created_byRef: STUDENT ? STUDENT.created_byRef : this.ds.userProfileRef().doc(user.uid).ref,
        updated_byRef: this.ds.userProfileRef().doc(user.uid).ref,
        dateOfBirth,
        firstName,
        lastName,
        package: memberOption,
        totalMonth: memberOption.totalMonth || 0,
        fullName: `${firstName} ${lastName}`,
        memberCreatedDate: firebase.firestore.FieldValue.serverTimestamp(),
        email,
        phoneNumber,
        gender: gender,
        photoFileDetail: STUDENT ? STUDENT.photoFileDetail : null,
        memberId: STUDENT ? STUDENT.memberId : memberId,
        studentId: STUDENT ? STUDENT.memberId : memberId,
        apps: apps,
        accountType: ACCOUNT_TYPE,
        displayName: lastName,
        appName: appName || null,
        program: program ? { key: program.key, name: program.name } : null,
        level: level ? { key: level.key, name: level.name } : null,
        //training
        photoURL: STUDENT ? STUDENT.photoURL || null : null,
        currentLevelRef: STUDENT ? STUDENT.currentLevelRef || null : null,
        currentAdmissionKey: STUDENT ? STUDENT.currentAdmissionKey || null : null,
        currentAdmissionRef: STUDENT ? STUDENT.currentAdmissionRef || null : null,
        currentLessonKey: STUDENT ? STUDENT.currentLessonKey || null : null,
        currentLessonRef: STUDENT ? STUDENT.currentLessonRef || null : null,
        currentLevelKey: STUDENT ? STUDENT.currentLevelKey || null : null,
        currentProgramKey: STUDENT ? STUDENT.currentProgramKey || null : null,
        currentProgramRef: STUDENT ? STUDENT.currentProgramRef || null : null,
        currentEnrollmentKey: STUDENT ? STUDENT.currentEnrollmentKey || null : null,
      }
      if (this.SELECTED_PICTURE_FILE) {
        this.START_UPLOAD = true;
        const file = this.SELECTED_PICTURE_FILE;
        const fileName = file.name;
        const uploadPath = `students/${item.key}/${this.ds.createId()}_${fileName}`;
        const uploadTask = this.storage.uploadSelectedFile(file, uploadPath);
        this.uploadPercent = uploadTask.percentageChanges();
        const files = await this.storage.getFileDetail(file, uploadPath, uploadTask)

        item.photoFileDetail = files;
        item.photoURL = files.downloadUrl,
          this.START_UPLOAD = false;
      }
      const enrollmentLevel = level || null;
      this.store.saveMember(item, enrollmentLevel, STUDENT ? false : true, (success, res) => {
        if (success) {
          this.snackBar.open("Member has been saved successful.", "Done", { duration: 1000 });
          if (!isNew || STUDENT) {
            this.dialogRef.close('no')
            return;
          }
          this.form.reset();
          this.form.enable();
          this.processNew = false;
          this.processClose = false;
          this.isCreate = false;
          this.SELECTED_PICTURE_FILE = null;
          this.imageSrc = null;
          this.inputEl.nativeElement.focus();
          this.form.patchValue({
            memberOption,
            gender,
            dateOfBirth,
            appName,
            program,
            level
          })
        }

      })
    }
    else {
      this.processNew = false;
      this.processClose = false;
      this.isCreate = false;
    }
  }
}
